export class CoreDataContextService {
  public readonly api = '/api/';
}
